import Spinner from './Spinner';

export default function Loading() {
  return (
    <div className="flex justify-center">
      <Spinner />
    </div>
  );
}
